import { Injectable } from '@angular/core';
import { PageMetaResolver, PageRobotsMeta, PageRobotsResolver, PageTitleResolver } from '@spartacus/core';
import { Observable } from 'rxjs';
import { BasePageMetaResolver } from '../../../../core/cms/page/base-page-meta.resolver';
import { PageType } from '../../../../core/model/cms.model';

@Injectable({
  providedIn: 'root',
})
export class CartPageMetaResolver extends PageMetaResolver implements PageTitleResolver, PageRobotsResolver {
  constructor(protected basePageMetaResolver: BasePageMetaResolver) {
    super();
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'CartPageTemplate';
  }

  resolveTitle(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveTitle();
  }

  resolveRobots(): Observable<PageRobotsMeta[] | undefined> {
    return this.basePageMetaResolver.resolveRobots();
  }
}
